/**
 * Utilidades para detectar overflow en elementos HTML
 */

/**
 * Verifica si un elemento está en overflow horizontal
 * @param element El elemento HTML a verificar
 * @returns true si el elemento está en overflow, false en caso contrario
 */
export function isElementOverflowing(element: HTMLElement): boolean {
  if (!element) return false;
  
  // Verificar overflow horizontal
  return element.scrollWidth > element.clientWidth;
}

/**
 * Verifica si un elemento está en overflow vertical
 * @param element El elemento HTML a verificar
 * @returns true si el elemento está en overflow, false en caso contrario
 */
export function isElementOverflowingVertically(element: HTMLElement): boolean {
  if (!element) return false;
  
  // Verificar overflow vertical
  return element.scrollHeight > element.clientHeight;
}

/**
 * Verifica si un elemento está en overflow (horizontal o vertical)
 * @param element El elemento HTML a verificar
 * @returns true si el elemento está en overflow, false en caso contrario
 */
export function isElementOverflowingAny(element: HTMLElement): boolean {
  return isElementOverflowing(element) || isElementOverflowingVertically(element);
}

/**
 * Función unificada para verificar si debe mostrar tooltip basado en overflow
 * @param element El elemento HTML a verificar
 * @param text El texto que se mostraría en el tooltip
 * @returns El texto del tooltip si hay overflow, null en caso contrario
 */
export function getTooltipTextIfOverflowing(element: HTMLElement, text: string): string | null {
  if (!element || !text) return null;
  
  return isElementOverflowing(element) ? text : null;
}

/**
 * Función para verificar si debe mostrar tooltip basado en overflow (versión booleana)
 * @param element El elemento HTML a verificar
 * @returns true si debe mostrar tooltip, false en caso contrario
 */
export function shouldShowTooltip(element: HTMLElement): boolean {
  return isElementOverflowing(element);
}
